import { Injectable, } from "@angular/core";
import { MICustomFunctionsParams } from "../../../../models/fields/custom-function-params";
import { MCCustomItemFourDigitsService, MCFormisFieldAutoCompleteService, MCPersonalImportService, MCRegex } from "@maslul/common-services";
import { RequestApprovalTypeDetailsStore } from "../../../store/approval-type-details-store";



@Injectable({
    providedIn: 'root'
})
export class MICustomBookService {



    initCustomItemList(customFunctionsObj: MICustomFunctionsParams) {
        const value = customFunctionsObj?.value;
        const injector = customFunctionsObj.injector;
        const personalImportService = injector.get(MCPersonalImportService);

        const formisFieldAutoCompleteService = injector.get(MCFormisFieldAutoCompleteService);
        const requestApprovalTypeDetailsStore = injector.get(RequestApprovalTypeDetailsStore);
        const customItemFourDigitsService: MCCustomItemFourDigitsService = injector.get(MCCustomItemFourDigitsService);

        const is4DigitsCustomItem = requestApprovalTypeDetailsStore.getSnapshot().is4DigitsCustomItem
            && customFunctionsObj.value?.length == 4;

        const customItemFieldSec = customFunctionsObj?.formisForm?.fields
            ?.find(x => x.key == 'customItem')

        const customItemField = customItemFieldSec?.fieldGroup?.find(x => x.key == 'transportCustomItem') || customItemFieldSec?.fieldGroup?.find(x => x.key == 'customItem');
        const fieldName = (customItemField?.key || 'customItem').toString() ;
        formisFieldAutoCompleteService.noMessage.next({ condition: false, fieldName: fieldName });

        if (MCRegex.digitsWithNegative.test(value) && value?.length >= 4) {
            //טוען נתונים רק לשדה ספציפי

            formisFieldAutoCompleteService.loadingList.next({ condition: true, fieldName:  fieldName });
            personalImportService.getCustomItemData(value).subscribe((res) => {
                formisFieldAutoCompleteService.noMessage.next({ condition: false, fieldName:  fieldName });

                formisFieldAutoCompleteService.loadingList.next({ condition: false, fieldName:  fieldName });
                const options = is4DigitsCustomItem ? customItemFourDigitsService.groupCustomItemBy4Digits(res) : res;
                if (customItemField?.props?.options) {
                    customItemField.props.options = options?.map((item: any) => ({ value: item.itemNum, label: item.itemNum })) || [];

                    formisFieldAutoCompleteService.externalRefreshList.next(true);
                }

            });

        }
        else {
            formisFieldAutoCompleteService.noMessage.next({ condition: true, fieldName:  fieldName });

            formisFieldAutoCompleteService.externalRefreshList.next(true);
        }
    }
}

